import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Media } from '../../../types/Media';
import Api from '../../api/api';

export type AdvertisementCreateDTO = {
  title: string;
  media: Media;
};

export const createAdvertisement = async (params: AdvertisementCreateDTO) => {
  const [response, bodyOrError] = await Api.post('advertisement', params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useCreateAdvertisement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('createAdvertisement', createAdvertisement, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['getAdvertisementsByPage']);
      setAlertSnackbar({
        message: `${data.title} created successfully.`,
        severity: 'success',
        vertical: 'top',
      });
      navigate('/cms/advertisements');
    },
  });
};
